/**
 * The host every answer composition point mounts. Components only — a file
 * exporting a hook beside one fails the `react-refresh/only-export-components`
 * ratchet, so the twelve-member binding lives in the sibling module.
 */

import { EvidenceAnswerPortsProvider } from '@heidi/evidence';
import { type ReactNode } from 'react';

import { useEvidenceAnswerPortsValue } from './use-evidence-answer-ports';

/**
 * Mount once above any subtree that renders an answer surface. A component
 * reading a port with no host above it throws and names the bundle, because a
 * degraded render would ship a badge with no analytics and no viewer routing
 * and look correct.
 */
export const EvidenceAnswerPortsHost = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  const ports = useEvidenceAnswerPortsValue();
  return (
    <EvidenceAnswerPortsProvider ports={ports}>{children}</EvidenceAnswerPortsProvider>
  );
};
